const config = {
    hostName: "https://i.vu.ac.th/volunteer_api",
  };

  //https://i.vu.ac.th/volunteer_api
  
  export default config;
  